<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("adicionar-fornecedor") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t("vendas") :
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'ven-fornecedor',
                                            })
                                        "
                                        >{{ $t("fornecedores") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="fecharModal"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao &&
                                    !isUpdate &&
                                    permissao.create) ||
                                (!usuarioIntegracao &&
                                    isUpdate &&
                                    permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-6">
                            <v-input 
                                id="idfornecedorerpInput"
                                ref="idErpInput"
                                v-model="fornecedor.idfornecedorerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :disabled="cantEdit"
                                :invalid="!fornecedor.idfornecedorerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="fornecedor.nome"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="nome"
                                msg="msg-campo-obrigatorio"
                                :invalid="
                                    fornecedor.nome == null ||
                                    fornecedor.nome == ''
                                "
                                :required="true"
                                tooltipLabel="informacao-fornecedor-nome"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>

                        <div class="column is-6">
                            <v-input
                                :id="generateId(2)"
                                ref="razaosocialInput"
                                v-model="fornecedor.rsocial"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="razaosocial"
                                tooltipLabel="informacao-fornecedor-rsocial"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                                :invalid="
                                    fornecedor.rsocial == null ||
                                    fornecedor.rsocial == ''
                                "
                                :required="true"
                            />
                        </div>

                        <div class="column is-6">
                            <v-input
                                :id="generateId(3)"
                                ref="enderecoInput"
                                v-model="fornecedor.endereco"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="endereco"
                                msg="msg-campo-obrigatorio"
                                :invalid="
                                    fornecedor.endereco == null ||
                                    fornecedor.endereco == ''
                                "
                                :required="true"
                                tooltipLabel="informacao-fornecedor-endereco"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(4)"
                                ref="bairroInput"
                                v-model="fornecedor.bairro"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="bairro"
                                msg="msg-campo-obrigatorio"
                                :invalid="
                                    fornecedor.bairro == null ||
                                    fornecedor.bairro == ''
                                "
                                :required="true"
                                tooltipLabel="informacao-fornecedor-bairro"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(5)"
                                ref="cidadeInput"
                                label="nome"
                                v-model="cidade"
                                placeholder="selecione"
                                title="cidade"
                                :options="cidades"
                                msg="msg-campo-obrigatorio"
                                :invalid="cidade == null ? true : false"
                                searchable
                                @search="loadCidade"
                                :required="true"
                                :onChange="updateCidade()"
                                tooltipLabel="informacao-fornecedor-cidade"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input-tel
                                :id="generateId(6)"
                                ref="telefoneInput"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                v-model="fornecedor.telefone"
                                title="telefone"
                                :edit="inputTelefoneEdit"
                                :msg="invalidTelefoneMsg"
                                :invalid="invalidTelefone"
                                :onBlurFunction="validateTelefone"
                                :required="true"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-6">
                            <v-input
                                :id="generateId(7)"
                                ref="contatoInput"
                                v-model="fornecedor.contato"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="contato"
                                tooltipLabel="informacao-fornecedor-contato"
                                tooltipSize="is-small"
                                uppercase
                                @input="sendIsChanged"
                                :disabled="cantEdit"
                            />
                        </div>

                        <div class="column is-6">
                            <v-input
                                :id="generateId(8)"
                                ref="emailInput"
                                v-model="fornecedor.email"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="email"
                                :msg="invalidEmailMsg"
                                :invalid="invalidEmail"
                                :onBlurFunction="validateEmailInner"
                                :required="true"
                                type="email"
                                tooltipLabel="informacao-fornecedor-email"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>

                        <div class="column is-6">
                            <v-input
                                :id="generateId(9)"
                                ref="siteInput"
                                v-model="fornecedor.site"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="site"
                                :msg="invalidURLMsg"
                                :invalid="invalidURL"
                                :onBlurFunction="validateURLInner"
                                :uppercase="false"
                                :required="false"
                                icon="open-in-new"
                                @input-action="openLink(fornecedor.site)"
                                tooltipLabel="informacao-fornecedor-site"
                                tooltipSize="is-small"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-10">
                            <v-input
                                :id="generateId(10)"
                                ref="obsInput"
                                v-model="fornecedor.obs"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="obs"
                                uppercase
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(11)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="fornecedor.id == null || cantEdit"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssFornecedorRestricaoCliente from "@/services/vendas/cliente/abas/AssFornecedorRestricaoClienteService";
import FornecedorService from "@/services/vendas/FornecedorService";
import cidadeService from "@/services/CidadeService";
import FornecedorValidation from "@/services/validations/FornecedorValidation";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
    components: {
        TheMask,
        HideInfo,
    },
    data() {
        return {
            assFornecedorRestricaoClienteIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "FORNECEDORRESTRICAO"
                ),
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("FORNECEDOR"),
            service: new FornecedorService(this.$http, this.$router),
            serviceAss: new AssFornecedorRestricaoCliente(
                this.$http,
                this.$router
            ),
            cidadeservice: new cidadeService(this.$http, this.$router),
            validations: new FornecedorValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            permissao: false,
            permissaoVincular: false,
            fornecedor: {
                id: null,
                idfornecedorerp: null,
                nome: null,
                rsocial: null,
                endereco: null,
                bairro: null,
                idcidade: null,
                cidade: null,
                estado: null,
                telefone: null,
                contato: "",
                email: null,
                site: null,
                obs: null,
                situacao: null,
            },
            isUpdate: false,
            invalidTelefone: false,
            invalidTelefoneMsg: "msg-campo-obrigatorio",
            invalidEmail: false,
            invalidEmailMsg: "msg-campo-obrigatorio",
            invalidURL: false,
            invalidURLMsg: "msg-campo-obrigatorio",
            cantEdit: false,
            inputTelefoneEdit: false,

            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            situacao: { label: "ativo", id: 1 },

            canSelectCidade: false,
            cidade: null,
            cidades: [],
            loadingCidade: false,
            isChanged: false,
            isLoadingEdit: false,

            isVenda: this.$route.query.contexto == "ven",

        };
    },
    watch: {
        fornecedor: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                } else if (!this.isUpdate) {
                    this.isLoadingEdit = false;
                }
            },
        },
    },
    created() {
        this.isChanged = false;
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-fornecedor"
        );
        this.permissaoVincular =
            this.permissao.create &&
            !this.assFornecedorRestricaoClienteIntegracao;
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "fornecedor" },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados();
                this.cantEdit = !this.permissao.update || this.usuarioIntegracao;
            } else {
                // para carregar o vss-select de cidade e carregar o campo situacao
                this.situacoes[this.situacao];
                this.loadCidade("", null);
            }
        }
        this.isLoadingEdit = true;
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        sendIsChanged() {
            if (!this.isLoadingEdit) this.isChanged = true;
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(this.$route.params.id)
                .then((value) => {
                    this.fornecedor = Object.assign({}, value.content);
                    this.situacao = this.situacoes[this.fornecedor.situacao];
                    if (
                        value.content.idcidade != null &&
                        value.content.idcidade != 0 &&
                        value.content.idcidade != ""
                    ) {
                        this.loadCidadeById(value.content.idcidade);
                    } else {
                        this.loadCidade(
                            value.content.cidade,
                            value.content.estado
                        );
                    }
                    this.checkEditTel();
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.$emit("isChanged", false);
                    }, 300);
                    setTimeout(() => {
                        this.runValidations(true);
                    }, 1000);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
            // Ao realizar o focusedOut no arquivo validation, as funções de validate não são chamadas, tendo assim que fazelas manualmente para poder apresentar os erros nos campos
            this.validateTelefone();
            this.validateEmailInner();
            this.validateURLInner();
        },
        loadCidadeById(id) {
            this.cidadeservice
                .find(id)
                .then((cidade) => {
                    if (cidade.content != null) {
                        let temp = {
                            id: cidade.content.id,
                            nome: cidade.content.descricao,
                        };
                        this.cidade = temp;
                    } else {
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    }
                }, 350)
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                });
        },
        loadCidade(cidade, estado = null) {
            if ((!cidade && this.cidade == null) || cidade) {
                this.cidadeservice
                    .findAll(0, 100, cidade ? cidade : "")
                    .then((body) => {
                        return body.content.map((i) => {
                            return {
                                id: i.idcidade,
                                cidade: i.cidade,
                                nome: i.descricao,
                                estado: i.estado.descricao,
                            };
                        });
                    })
                    .then((allcidades) => {
                        this.cidades = Object.assign(allcidades);
                        this.cidades.sort();
                    }, 350)
                    .finally((_) => {
                        if (estado != null) {
                            let idcidade = this.cidades.filter(
                                (s) => s.estado == estado
                            );
                            if (idcidade.length > 0) {
                                this.loadCidadeById(idcidade[0].id);
                            }
                        }
                    });
            }
        },
        mapItems(body) {
            let list = body.content.map((i) => {
                return {
                    id: i,
                    label: i.descricao,
                };
            });
            return list;
        },
        updateCidade() {
            if (this.cidade != null) {
                let cidadeTemp = this.cidades.filter(
                    (s) => s.id == this.cidade.id
                )[0];
                if (cidadeTemp != undefined) {
                    this.fornecedor.idcidade = cidadeTemp.id;
                    this.fornecedor.cidade = cidadeTemp.cidade;
                    this.fornecedor.estado = cidadeTemp.estado;
                }
            }
        },
        validateTelefone() {
            if (this.isNull(this.fornecedor.telefone)) {
                this.invalidTelefone = true;
                this.invalidTelefoneMsg = "msg-campo-obrigatorio";
            } else if (!this.validatePhone(this.fornecedor.telefone)) {
                this.invalidTelefone = true;
                this.invalidTelefoneMsg = "msg-campo-invalido";
            } else {
                this.invalidTelefone = false;
            }
        },
        validateEmailInner() {
            if (this.isNull(this.fornecedor.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = "msg-campo-obrigatorio";
            } else if (!this.validateEmail(this.fornecedor.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = "msg-campo-invalido";
            } else {
                this.invalidEmail = false;
            }
        },
        validateURLInner() {
            if (
                (!this.validateURL(this.fornecedor.site) ||
                    !this.validateDominioURL(
                        this.fornecedor.site.toLowerCase()
                    )) &&
                this.fornecedor.site
            ) {
                this.invalidURL = true;
                this.invalidURLMsg = "msg-campo-invalido";
            } else {
                this.invalidURL = false;
            }
        },
        save() {
            if (
                (!this.validateURL(this.fornecedor.site) ||
                    !this.validateDominioURL(
                        this.fornecedor.site.toLowerCase()
                    )) &&
                this.fornecedor.site
            ) {
                this.msgs.push(
                    new Message("alert", "msg-campos-invalidos", true)
                );
                this.$refs.siteInput.focusedOut = true;
                return;
            }

            this.isLoading = true;
            this.isLoadingEdit = true;
            if (this.validations.validate(this.fornecedor, this.$refs)) {
                let fornecedorTemp = Object.assign({}, this.fornecedor);
                fornecedorTemp = this.mapTosave(fornecedorTemp);
                fornecedorTemp.situacao = this.situacao.id;
                this.invalidIcon = false;
                this.isSaving = true;
                this.service
                    .save(fornecedorTemp)
                    .then((value) => {
                        if (value.content) {
                            let msg = "msg-save-fornecedor";
                            if (this.fornecedor.idfornecedor != null) {
                                msg = "msg-edit-fornecedor";
                            }
                            this.isChanged = false;
                            this.msgs.push(new Message("success", msg, true));
                            // @85242
                            if (
                                this.permissaoVincular &&
                                !this.isUpdate &&
                                this.$route.query.tela == "retricao-forncedor"
                            ) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.redirectToPage();
                            }
                        } else {
                            let message = value.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: fornecedorTemp.idfornecedorerp }), 
                                        true, false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(new Message(
                                    'alert', 
                                    this.$t(message, { n: fornecedorTemp.idfornecedorerp }), 
                                    true, 
                                    false
                                ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
                this.isLoading = false;
            }
        },
        openLocationEditor() {
            if (!this.isNull(this.fornecedor.endereco))
                this.startSearchWith = this.fornecedor.endereco;
            if (!this.isNull(this.fornecedor.bairro))
                this.startSearchWith =
                    this.startSearchWith + " " + this.fornecedor.bairro;
            if (!this.isNull(this.fornecedor.cidade))
                this.startSearchWith =
                    this.startSearchWith + " " + this.fornecedor.cidade;
            if (!this.isNull(this.fornecedor.estado))
                this.startSearchWith =
                    this.startSearchWith + " " + this.fornecedor.estado;

            this.locationEditorOpen = true;
        },

        // @85242
        promptConfirmaVinculo(vinculo) {
            this.$root.confirm({
                message: this.$t("deseja-realizar-vinculo"),
                onConfirm: (_) => {
                    this.realizarVinculo(vinculo);
                },
                onCancel: (_) => {
                    this.redirectToPage();
                },
            });
        },

        // @85242
        realizarVinculo(vinculo) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            let fornecedorRestricaoTemp = {
                fornecedor: this.fornecedor,
                idcliente: this.$route.query["id"],
                idfornecedor: vinculo.idfornecedor,
            };
            this.serviceAss
                .saveAss(fornecedorRestricaoTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage(
                            "success",
                            "msg-sucesso-ao-adicionar-associacao"
                        );
                        this.redirectToPage();
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(
                                new Message("alert", value.message, true)
                            );
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },

        fecharModal() {
            // @85242
            if (this.isChanged) {
                this.$root.confirm({
                    message: this.$t("msg-tem-certeza-alteracoes"),
                    onConfirm: (_) => {
                        this.isChanged = false;
                        this.redirectToPage();
                    },
                });
            } else {
                this.redirectToPage();
            }
        },

        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            // @71191 - voltando para tela de clientes - aba restricao-fornecedor
            if (
                this.$route.query.tela == "cliente-fornecedor" ||
                this.$route.query.tela == "produto-fornecedor"
            ) {
                tempTela =
                    this.$route.query.tela == "cliente-fornecedor"
                        ? `${this.$route.query.contexto}-cliente-politica-comercial-edit`
                        : "ven-produto-dados-cadastrais-edit";
                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: {
                            id: this.$route.query["id"],
                        },
                        query: {
                            dadoscadastrais: this.$route.query.dadoscadastrais,
                            politicacomercial: this.$route.query.politicacomercial,
                            analisecomercial: this.$route.query.analisecomercial,
                        },
                    });
                }, 1000);
            } else {
                tempTela = "ven-fornecedor";
                setTimeout(
                    () => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query["id"] },
                            query: { abaSelecionada: tempAba },
                        });
                    },
                    tempAba != null ? 0 : 1000
                );
            }
        },
        checkEditTel() {
            this.inputTelefoneEdit = !this.isNull(this.fornecedor.telefone);
        },
        openLink(link) {
            if (!link.startsWith("http")) link = `http://${link}`;
            window.open(link.toLowerCase(), "_blank");
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
    .nome-input {
        width: 49.5%;
    }
    .razao-social-input {
        width: 49.5%;
    }
}
</style>
